export const sliderItem = [
    {
        id: 1,
        img: "https://cdn.pixabay.com/photo/2015/12/06/18/28/capsules-1079838_960_720.jpg",
        title: "Protein Capsule",
        desc: "Get Protein Capsule that needed for your health.",
        bg: "f5fafd",
    },
    {
        id: 2,
        img: "https://cdn.pixabay.com/photo/2020/10/02/09/01/tablets-5620566__340.jpg",
        title: "Protein Capsule",
        desc: "Get Protein Capsule that needed for your health.",
        bg: "fcf1ed",
    },
    {
        id: 3,
        img: "https://cdn.pixabay.com/photo/2014/07/05/15/16/pills-384846_960_720.jpg",
        title: "Protein Capsule",
        desc: "Get Protein Capsule that needed for your health.",
        bg: "fbf0f4",
    },

];

export const popularProducts = [
    {
        id:1,
        img:"https://5.imimg.com/data5/YH/JH/LW/SELLER-3468355/levothyroxine-sodium-500x500.jpg",
    },
    {
        id:2,
        img:"https://www.prescriptiondrugjournal.com/wp-content/uploads/2016/08/Lipitor.jpg",
    },
    {
        id:3,
        img:"https://cdn01.pharmeasy.in/dam/products_otc/000591/abzorb-anti-fungal-powder-100-gm-6.2-1637510413.jpg",
    },
    {
        id:4,
        img:"https://cdn01.pharmeasy.in/dam/products_otc/207833/calcimax-forte-plus-strip-of-30-tablets-6.1-1637510003.jpg",
    },
    {
        id:5,
        img:"https://cdn01.pharmeasy.in/dam/products_otc/T22634/liveasy-wellness-calcium-magnesium-vitamin-d3-bones-dental-health-bottle-of-60-tablets-2-1637565394.jpg",
    },
    {
        id:6,
        img:"https://cdn01.pharmeasy.in/dam/products_otc/Y79593/everherb-jointcare-blend-of-9-powerful-herbs-joint-bone-health-bottle-of-60-tablets-2-1637518200.jpg",
    },
    {
        id:7,
        img:"https://cdn01.pharmeasy.in/dam/products_otc/Z96268/sandpuppy-heatwrap-multipurpose-electric-heating-wrap-black-for-back-shoulder-elbow-knee-pain-relief-1-1632777017.jpg",
    },
    {
        id:8,
        img:"https://cdn01.pharmeasy.in/dam/products_otc/067825/ensure-vanilla-nutrition-drink-refill-of-400-g-1-1637514902.jpg",
    },
    {
        id:9,
        img:"https://cdn01.pharmeasy.in/dam/products_otc/R05584/jus-amazin-crunchy-organic-peanut-butter-unsweetened-1kg-clean-nutrition-2-1642006742.jpg",
    },
    {
        id:10,
        img:"https://cdn01.pharmeasy.in/dam/products_otc/I13844/nepro-hp-vanilla-toffee-flav-pow-400gm-2-1641787950.jpg",
    },
    {
        id:11,
        img:"https://m.media-amazon.com/images/I/81ROkatqrLL._AC_SL1500_.jpg",
    },
    {
        id:12,
        img:"https://cdn01.pharmeasy.in/dam/products_otc/I40124/dettol-antiseptic-liquid-bottle-of-1-l-2-1651045402.jpg",
    },
    {
        id:13,
        img:"https://cdn01.pharmeasy.in/dam/products_otc/J47511/bold-care-surge-60-tablets-2-1641792358.jpg",
    },
    {
        id:14,
        img:"https://cdn01.pharmeasy.in/dam/products_otc/I40936/nivea-sun-moisturising-lotion-spf-50-75ml-2-1641788374.jpg",
    },
    {
        id:15,
        img:"https://cdn01.pharmeasy.in/dam/products_otc/I14061/indulekha-bringha-hair-oil-bottle-of-50-ml-2-1654167331.jpg",
    },
]


